module.exports = __webpack_public_path__ + "img/MESSENGER_1.6cf812f2.png";